const SEP = '::';

/**
 * Stable composite id for routing / cart / wishlist when aggregating multiple shops.
 * First segment is the tenant **`shop_id`** (UUID). It must not contain "::".
 */
export function makeGlobalProductId(shopId: string, localProductId: string): string {
  return `${shopId}${SEP}${localProductId}`;
}

export function parseGlobalProductId(
  compositeId: string
): { shopId: string; localProductId: string } | null {
  const idx = compositeId.indexOf(SEP);
  if (idx <= 0 || idx === compositeId.length - SEP.length) return null;
  return {
    shopId: compositeId.slice(0, idx),
    localProductId: compositeId.slice(idx + SEP.length),
  };
}

export function isGlobalProductId(id: string): boolean {
  return id.includes(SEP);
}
